import types from '../../constants';

const initialState = {
  variableInput: {},
  newVariableKey: '',
  newVariableValue: '',
  loading: false,
};

const ExerciseVariablesReducers = (state = initialState, action) => {
  let newVariables;
  switch (action.type) {
    case types.EXERCISE_VARIABLES_CHANGE_VARIABLE_INPUT:
      newVariables = { ...state.variableInput };

      newVariables[action.payload.key] = action.payload.value;

      return {
        ...state,
        variableInput: newVariables,
      };
    case types.EXERCISE_VARIABLES_COPY_VARIABLES:
      return {
        ...state,
        variableInput: action.payload,
      };
    case types.EXERCISE_SET_VAR:
      newVariables = { ...state.variableInput };

      newVariables[action.payload.key] = action.payload.value;

      return {
        ...state,
        variableInput: newVariables,
        newVariableKey: '',
        newVariableValue: '',
      };
    case types.EXERCISE_VARIABLES_LOADING_START:
      return {
        ...state,
        loading: true,
      };
    case types.EXERCISE_VARIABLES_LOADING_END:
      return {
        ...state,
        loading: false,
      };
    case types.EXERCISE_VARIABLES_CHANGE_NEW_VARIABLE_KEY:
      return {
        ...state,
        newVariableKey: action.payload,
      };
    case types.EXERCISE_VARIABLES_CHANGE_NEW_VARIABLE_VALUE:
      return {
        ...state,
        newVariableValue: action.payload,
      };
    case types.EXERCISE_CLEAR:
      return initialState;
    default:
      return state;
  }
};

export default ExerciseVariablesReducers;
